import { writable, derived } from 'svelte/store';
import translations from './translations';

/**
 * Currently we just derive the language from the pathname, because the webflow translation strategy has changed.
 * The store is not really necessary because it never changes. Previously we needed to set it dynamically
 * once the page loaded based on the translation plugin, which is why there is a reactive svelte store.
 * I'm leaving the store in place in case we need to switch this back in the future.
 */
function getInitialLangFromPathname() {
  const pathname = window.location.pathname;
  if (pathname.includes('/en/') || pathname === '/en') {
    return 'en';
  } else {
    return 'de';
  }
}

// todo: remove once weglot is removed
function getInitialLangFromWeglot() {
  return window.localStorage.getItem('wglang') || 'de';
}

const IS_WEGLOT_ENABLED = window.Weglot?.initialized;

export const dict = writable();
export const locale = writable(
  IS_WEGLOT_ENABLED ? getInitialLangFromWeglot() : getInitialLangFromPathname()
);

$: dict.set(translations);

// Make method global so language switcher can access it
// todo: remove once weglot is removed
window.setLanguage = (lang) => {
  locale.set(lang);
};

const localizedDict = derived([dict, locale], ([$dict, $locale]) => {
  if (!$dict || !$locale) return;
  return $dict[$locale];
});

const getMessageFromLocalizedDict = (id, localizedDict) => {
  const splitId = id.split('.');
  let message = { ...localizedDict };
  splitId.forEach((partialId) => {
    message = message[partialId];
  });
  return message;
};

const createMessageFormatter = (localizedDict) => (id) =>
  getMessageFromLocalizedDict(id, localizedDict);

export const t = derived(localizedDict, ($localizedDict) => {
  return createMessageFormatter($localizedDict);
});
